import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
	onChange: (value: string) => void;
	settingsId: string;
}

export const MerchantAccountField: React.FC<IProps> = React.memo(({ onChange, settingsId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterMerchantAccount') }], [t]);

	return (
		<FormInput
			testId="MerchantAccountField"
			name={`merchantAccount-${settingsId}`}
			label="merchantAccountLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
});
